
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/certificate/[id]",
      function () {
        return require("private-next-pages/learn/certificate/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/certificate/[id]"])
      });
    }
  